/**
 * Embedded Lottie JSON animations — Islamic theme
 * These are self-contained and require no external CDN
 */

/** Crescent moon gentle pulse — used for Isha / night decorations */
export const crescentPulseLottie = {
  v: "5.7.8", fr: 30, ip: 0, op: 90, w: 64, h: 64, nm: "crescent_pulse",
  ddd: 0, assets: [],
  layers: [{
    ddd: 0, ind: 1, ty: 4, nm: "crescent", sr: 1, ao: 0,
    ks: {
      o: { a: 1, k: [{ i:{x:[.833],y:[.833]}, o:{x:[.167],y:[.167]}, t: 0, s:[100]}, { i:{x:[.833],y:[.833]}, o:{x:[.167],y:[.167]}, t:45, s:[55]}, {t:90, s:[100]}] },
      r: { a: 0, k: 0 },
      p: { a: 0, k: [32,32,0] },
      a: { a: 0, k: [0,0,0] },
      s: { a: 1, k: [{ i:{x:[.833],y:[.833]}, o:{x:[.167],y:[.167]}, t:0, s:[100,100,100]}, { i:{x:[.833],y:[.833]}, o:{x:[.167],y:[.167]}, t:45, s:[88,88,100]}, {t:90, s:[100,100,100]}] }
    },
    shapes: [{
      ty: "gr", nm: "crescent_shape",
      it: [
        { ty:"el", nm:"outer", p:{a:0,k:[0,0]}, s:{a:0,k:[44,44]} },
        { ty:"fl", nm:"fill", c:{a:0,k:[0.98,0.75,0.14,1]}, o:{a:0,k:100}, r:1 },
        { ty:"tr", p:{a:0,k:[0,0]}, a:{a:0,k:[0,0]}, s:{a:0,k:[100,100]}, r:{a:0,k:0}, o:{a:0,k:100} }
      ]
    }],
    ip: 0, op: 90, st: 0, bm: 0
  }]
};

/** Star sparkle — for celebrations and achievements */
export const starSparkleLottie = {
  v: "5.7.8", fr: 30, ip: 0, op: 60, w: 64, h: 64, nm: "star_sparkle",
  ddd: 0, assets: [],
  layers: [{
    ddd: 0, ind: 1, ty: 4, nm: "star", sr: 1, ao: 0,
    ks: {
      o: { a: 0, k: 100 },
      r: { a: 1, k: [{ i:{x:[.833],y:[.833]}, o:{x:[.167],y:[.167]}, t:0, s:[0]}, {t:60, s:[360]}] },
      p: { a: 0, k: [32,32,0] },
      a: { a: 0, k: [0,0,0] },
      s: { a: 1, k: [{ i:{x:[.833],y:[.833]}, o:{x:[.167],y:[.167]}, t:0, s:[60,60,100]}, { t:30, s:[110,110,100]}, {t:60, s:[60,60,100]}] }
    },
    shapes: [{
      ty: "gr", nm: "star_shape",
      it: [
        { ty:"sr", nm:"star", sy:1, d:1, pt:{a:0,k:5}, p:{a:0,k:[0,0]}, r:{a:0,k:0}, ir:{a:0,k:10}, is:{a:0,k:0}, or:{a:0,k:22}, os:{a:0,k:0} },
        { ty:"fl", nm:"fill", c:{a:0,k:[0.98,0.75,0.14,1]}, o:{a:0,k:100}, r:1 },
        { ty:"tr", p:{a:0,k:[0,0]}, a:{a:0,k:[0,0]}, s:{a:0,k:[100,100]}, r:{a:0,k:0}, o:{a:0,k:100} }
      ]
    }],
    ip: 0, op: 60, st: 0, bm: 0
  }]
};

/** Prayer beads (Tasbih) rotation — for tracker/remembrance */
export const tasbihLottie = {
  v: "5.7.8", fr: 30, ip: 0, op: 120, w: 64, h: 64, nm: "tasbih",
  ddd: 0, assets: [],
  layers: [{
    ddd: 0, ind: 1, ty: 4, nm: "beads", sr: 1, ao: 0,
    ks: {
      o: { a: 0, k: 100 },
      r: { a: 1, k: [{ i:{x:[.833],y:[.833]}, o:{x:[.167],y:[.167]}, t:0, s:[0]}, {t:120, s:[360]}] },
      p: { a: 0, k: [32,32,0] },
      a: { a: 0, k: [0,0,0] },
      s: { a: 0, k: [100,100,100] }
    },
    shapes: [{
      ty: "gr", nm: "bead_ring",
      it: [
        { ty:"el", nm:"ring", p:{a:0,k:[0,0]}, s:{a:0,k:[40,40]} },
        { ty:"st", nm:"stroke", c:{a:0,k:[0.25,0.53,0.42,1]}, o:{a:0,k:100}, w:{a:0,k:4}, lc:2, lj:1, ml:4,
          d:[{ n:"d", nm:"dash", v:{a:0,k:8}},{ n:"g", nm:"gap", v:{a:0,k:5}}] },
        { ty:"tr", p:{a:0,k:[0,0]}, a:{a:0,k:[0,0]}, s:{a:0,k:[100,100]}, r:{a:0,k:0}, o:{a:0,k:100} }
      ]
    }],
    ip: 0, op: 120, st: 0, bm: 0
  }]
};
